module.exports = __webpack_public_path__ + "_assets/img/payment-apply.05f8eac3.svg";